import { useMemo } from 'react'

/**
 * Custom hook to check if localStorage is available.
 * Followed the approach from:
 * https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#feature-detecting_localstorage
 *
 * @returns {boolean} - `true` if localStorage is available, `false` otherwise.
 */
const useIsLocalStorageAvailable = (): boolean => {
  const isAvailable = useMemo(() => {
    if (typeof window === 'undefined') {
      return false
    }

    try {
      const testKey = '__test__'
      window.localStorage.setItem(testKey, testKey)
      window.localStorage.removeItem(testKey)

      return true
    } catch {
      return false
    }
  }, [])

  return isAvailable
}

export { useIsLocalStorageAvailable }
